import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'avatar-wizard',
  templateUrl: './avatar-wizard.component.html',
  styleUrls: ['./avatar-wizard.component.scss']
})
export class AvatarWizardComponent implements OnInit, OnDestroy {
  @ViewChild('rpmFrame', { static: false }) rpmFrameElement: ElementRef<HTMLIFrameElement>

  constructor(
    public dialogRef: MatDialogRef<AvatarWizardComponent>
  ) {
    this.onIframeMessage = this.onIframeMessage.bind(this);
  }
  ngOnInit() {
    window.addEventListener("message", this.onIframeMessage);
  }

  ngOnDestroy() {
    window.removeEventListener("message", this.onIframeMessage);
  }


  /** ref doc https://docs.readyplayer.me/ready-player-me/integration-guides/web-and-native-integration/quickstart */
  async onIframeMessage(message: any): Promise<void> {
    let json;
    try {
      json = JSON.parse(message.data);
    } catch (e) {
      return;
    }

    if (json?.source !== 'readyplayerme') {
      return;
    }
    // Subscribe to all events sent from Ready Player Me once frame is ready
    if (json.eventName === 'v1.frame.ready') {
      this.rpmFrameElement.nativeElement.contentWindow.postMessage(
        JSON.stringify({
          target: 'readyplayerme',
          type: 'subscribe',
          eventName: 'v1.**'
        }),
        '*'
      );
    }

    if (json.eventName === 'v1.avatar.exported') {
      const newNpcUrl = json.data.url;
      this.dialogRef.close(json.data.url);
    }
  }
}
